import {Vue, Prop, Watch} from 'nuxt-property-decorator'
import {FieldsId} from '@pp-frontend/shared-packages/types/enum/FieldsId'
/**
 * класс описывает инпут поиска по грз
 */
export default abstract class extends Vue {
  @Prop() isError!: boolean
  @Prop() required!: boolean
  @Prop({
    type: String,
    default: ''
  }) value!: string

  @Prop({
    type: String,
    default: ''
  }) idPrefix!: string

  @Prop({default: true}) movePointer!: boolean

  // @ts-ignore
  id: string = this.$nuxt._uid
  plateReg: string = this.value.substr(6)
  numId: string = this.idPrefix + FieldsId.PLATE_NUM
  regId: string = this.idPrefix + FieldsId.PLATE_REG
  // разрешенные для ввода символы:
  // ру буквы = A,B,E,K,M,H,O,P,C,T,У,X;
  // англ буквы = А,В,Е,К,М,Н,О,Р,С,Т,Y,Х - англ автоматически переводим на ру
  plateNumPattern = /[АВЕКМНОРСТУХавекмнорстухABEKMHOPCTYXabekmhopctyx]/
  plateNumPatternWithNums = /[0-9]|[АВЕКМНОРСТУХавекмнорстухABEKMHOPCTYXabekmhopctyx]/
  isTooltipShown: boolean = false


  @Watch('$route', {deep: true})
  fillLicencePlate() {
    // @ts-ignore
    const licencePlate: string = (this.$route.query.additional_fields
      // @ts-ignore
      ? (this.$route.query.additional_fields as any).licence_plate
      // @ts-ignore
      : this.$route.query.licence_plate) || ''
    if (licencePlate) {
      // @ts-ignore
      this.plateNum = licencePlate.substr(0, 6)
      this.plateReg = licencePlate.substr(6)
      // @ts-ignore
      this.$emit('input', licencePlate.replace(/\s+/g, ''))
    }
  }
}
